import React from 'react';

export function EmailIcon({ ...other }) {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 18' width='20' height='20' color='#fff' {...other}>
            <path className='mail-icon' fill='currentColor' d='M16.31,2.25H1.69A1.69,1.69,0,0,0,0,3.94V14.06a1.69,1.69,0,0,0,1.69,1.69H16.31A1.69,1.69,0,0,0,18,14.06V3.94A1.69,1.69,0,0,0,16.31,2.25Zm0,1.69V5.37c-.79.64-2,1.64-4.73,3.75C11,9.58,9.82,10.7,9,10.69S7,9.58,6.42,9.12C3.73,7,2.48,6,1.69,5.37V3.94ZM1.69,14.06V7.54c.8.64,2,1.54,3.69,2.9.77.61,2.11,1.94,3.62,1.93s2.83-1.3,3.62-1.93c1.74-1.36,2.89-2.26,3.69-2.9v6.52Z' />
        </svg>
    );
}